// 类型定义

export type ZodiacSign =
  | 'Aries' | 'Taurus' | 'Gemini' | 'Cancer'
  | 'Leo' | 'Virgo' | 'Libra' | 'Scorpio'
  | 'Sagittarius' | 'Capricorn' | 'Aquarius' | 'Pisces'

export const ZodiacSignNames: Record<ZodiacSign, string> = {
  Aries: '白羊座', Taurus: '金牛座', Gemini: '双子座', Cancer: '巨蟹座',
  Leo: '狮子座', Virgo: '处女座', Libra: '天秤座', Scorpio: '天蝎座',
  Sagittarius: '射手座', Capricorn: '摩羯座', Aquarius: '水瓶座', Pisces: '双鱼座',
}

export const ZodiacSignSymbols: Record<ZodiacSign, string> = {
  Aries: '♈', Taurus: '♉', Gemini: '♊', Cancer: '♋',
  Leo: '♌', Virgo: '♍', Libra: '♎', Scorpio: '♏',
  Sagittarius: '♐', Capricorn: '♑', Aquarius: '♒', Pisces: '♓',
}

export type Planet =
  | 'sun' | 'moon' | 'mercury' | 'venus' | 'mars'
  | 'jupiter' | 'saturn' | 'uranus' | 'neptune' | 'pluto'

export const PlanetNames: Record<Planet, string> = {
  sun: '太阳', moon: '月亮', mercury: '水星', venus: '金星', mars: '火星',
  jupiter: '木星', saturn: '土星', uranus: '天王星', neptune: '海王星', pluto: '冥王星',
}

export const CyberPlanetNames: Record<Planet, string> = {
  sun: '核心处理器', moon: '缓存区', mercury: '传输协议', venus: '渲染引擎', mars: '驱动程序',
  jupiter: '扩展协议', saturn: '约束协议', uranus: '突变引擎', neptune: '幻象生成器', pluto: '重构协议',
}

export const CyberHouseNames: Record<number, string> = {
  1: '核心ID', 2: '资产池', 3: '局域网', 4: '根目录',
  5: '创意引擎', 6: '系统维护', 7: '配对协议', 8: '防火墙',
  9: '云端', 10: '算力峰值', 11: '共识网络', 12: '暗网层',
}

export interface PlanetPosition {
  longitude: number
  sign: ZodiacSign
  degree: number
  house: number
  retrograde: boolean
}

export interface House {
  number: number
  sign: ZodiacSign
  degree: number
}

export type AspectType = 'conjunction' | 'sextile' | 'square' | 'trine' | 'opposition'

export interface Aspect {
  planet1: string
  planet2: string
  aspect: AspectType
  orb: number
}

export interface ChartData {
  planets: Record<string, PlanetPosition>
  houses: House[]
  aspects: Aspect[]
  ascendant: { longitude: number; sign: ZodiacSign; degree: number }
  midheaven: { longitude: number; sign: ZodiacSign; degree: number }
}

export interface Chart {
  id: string
  userId?: number
  name: string
  birthDate: string
  birthTime: string
  birthLocation: string
  chartData: ChartData
  createdAt: string
}

export interface User {
  id: number
  email: string
  username: string | null
  displayName: string | null
  avatarUrl: string | null
}

export interface ApiResponse<T = unknown> {
  success: boolean
  data?: T
  message?: string
  error?: { code: string; message: string }
}

// 星盘类型
export type ChartType = 
  | 'natal'        // 本命盘
  | 'transit'      // 行运盘
  | 'progressed'   // 次限盘
  | 'solar_arc'    // 太阳弧
  | 'tertiary'     // 三限盘
  | 'synastry'     // 比较盘
  | 'composite'    // 组合中点盘
  | 'davison';     // 时空中点盘

// 星盘类型显示名称
export const ChartTypeNames: Record<ChartType, { name: string; desc: string; icon: string }> = {
  natal: { name: '本命盘', desc: '个人出生时刻的星盘', icon: '👤' },
  transit: { name: '行运盘', desc: '当前行星对个人星盘的影响', icon: '🌟' },
  progressed: { name: '次限盘', desc: '一年代表一生的推运方法', icon: '📈' },
  solar_arc: { name: '太阳弧', desc: '以太阳移动弧度的推运', icon: '☀️' },
  tertiary: { name: '三限盘', desc: '一天代表一个月的推运', icon: '🌙' },
  synastry: { name: '比较盘', desc: '两人星盘的相互影响', icon: '💕' },
  composite: { name: '组合盘', desc: '两人中点组合的星盘', icon: '🔗' },
  davison: { name: '时空盘', desc: '时空中点计算的星盘', icon: '⏰' },
};
